import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { useRemovePlaylistMutation } from "store/current-user/current-user.api";
import { ReactComponent as DeleteSVG } from "assets/images/delete-outline-red.svg";

export const PlaylistRemoveConfirmationMenu: FC = () => {
  const { playlistRemoveConfirmationMenu } = useShallowPickSelector("app", [
    "playlistRemoveConfirmationMenu",
  ]);
  const { user } = useShallowPickSelector("currentUser", ["user"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const [removePlaylist] = useRemovePlaylistMutation();

  const onClose = () => {
    dispatch(
      appActions.setPlaylistRemoveConfirmationMenu({
        isOpen: false,
        playlist: null,
      })
    );
  };

  const onClickRemovePlaylist: MouseEventHandler = () => {
    if (!user || !playlistRemoveConfirmationMenu.playlist) return;
    removePlaylist({ playlistId: playlistRemoveConfirmationMenu.playlist.id });
    dispatch(
      appActions.setPlaylistMenu({
        isOpen: false,
        playlist: null,
        isEditable: false,
      })
    );
    onClose();
    navigate("/tabs/profile"); //TODO remove removed playlist from navigation history
  };

  return (
    <BottomSheet
      isOpen={playlistRemoveConfirmationMenu.isOpen}
      onClose={onClose}
    >
      <Stack alignItems={"center"} mt={3}>
        <Box
          borderRadius={"50%"}
          px={5.2}
          pb={4.5}
          pt={5}
          bgcolor={"rgba(255,95,95,0.1)"}
        >
          <DeleteSVG height={"40px"} width={"40px"} />
        </Box>
        <Typography fontSize={"1.125rem"} fontWeight={700} mt={4}>
          حذف پلی‌لیست
        </Typography>
        <Typography
          fontSize={"0.875rem"}
          fontWeight={400}
          color={"rgba(255,255,255,0.5)"}
          mb={4}
        >
          آیا از حذف این پلی‌لیست مطمئن هستید؟
        </Typography>
        <Stack mx={5} alignSelf={"stretch"} spacing={1}>
          <Button
            variant={"contained"}
            fullWidth
            onClick={onClickRemovePlaylist}
          >
            حذف
          </Button>
          <Button color={"secondary"} fullWidth onClick={onClose}>
            انصراف
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
